export class SetModal {
  static readonly type = '[SHARED] Set Modal';
}

export class SetAuthorized {
  static readonly type = '[SHARED] Set authorized';
  constructor(public payload: boolean) {}
}

export class Logout {
  static readonly type = '[SHARED] Logout';
  constructor() {}
}

export class NavigateToUserProfile {
  static readonly type = '[SHARED] NavigateToProfile';
  constructor() {}
}
